export default "__VITE_PUBLIC_ASSET__ab852264__"